<template>
  <div>
    <el-dialog
      :visible="isOpen"
      append-to-body
      :show-close="true"
      :before-close="cancel"
      custom-class="tag-dialog"
      top="5vh"
    >
      <div class="tips_box">
        <svg-icon class="tips" icon-class="tips">tips：</svg-icon>广告主最多可选3个标签，且标签总字数之和不超过16个中文字符，中英文均算1个字
      </div>
      <div class="custom-input">
        <el-input v-model="custom_tag" placeholder="请输入自定义标签文案，按回车键生成标签，单标签2-7字" @keyup.enter.native="handleCustomTag" />
      </div>
      <div v-loading="loading" class="tag-box">
        <el-form label-position="left" size="mini" label-width="10%">
          <template v-for="(item,index) in tag.response.list">
            <div v-if="item.labels.length" :key="index">
              <el-divider />
              <el-form-item :label="item.label_category">
                <el-button
                  v-for="(_item,_index) in item.labels"
                  :key="_index"
                  round
                  :type="callback.tags.find(_data=>_data.content === _item) ? 'primary':''"
                  class="tag_item"
                  @click="tagCheck(_item, item.label_category)"
                >{{ _item }}</el-button>
              </el-form-item>
            </div>
          </template>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <div style="float: left">
          已选标签数
          <i>{{ callback.tags.length }}/3</i>
          , 总字数
          <i>{{ show_data.tags_length }}/{{ limit.max_length }}</i>
        </div>
        <el-button size="mini" @click="cancel">取 消</el-button>
        <el-button size="mini" type="primary" @click="confirm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { CHANNEL_INTERFACE_TYPE } from '@/enums';
import { getLabelListApi } from '@/api/tool/label';

export default {
  name: 'Tag',
  props: {
    advertiserId: {
      type: [Number, String],
      default: null,
    },
    data: {
      type: Array,
      default: null,
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
    limit: {
      type: Object,
      default: () => {
        return {
          max_length: 16,
          min_length: 2,
        };
      },
    },
  },
  data() {
    return {
      loading: false,
      tag: {
        response: { list: this.$store.getters.gdtLabel },
      },
      callback: {
        tags: [],
      },
      show_data: {
        // 标签总字数
        tags_length: 0,
      },
      custom_tag: '',
      custom_tag_list: {
        labels: [],
        label_category: '自定义标签',
      },
    };
  },
  created() {
    this.init();
  },
  methods: {
    /** 初始化标签数据 */
    init() {
      if (this.data) {
        this.callback.tags = JSON.parse(JSON.stringify(this.data));
      }
      this.loading = true;
      getLabelListApi({
        channel_interface: CHANNEL_INTERFACE_TYPE.GDT,
        advertiser_id: this.advertiserId,
      }).then(res => {
        this.tag.response.list = res.list;
        this.tag.response.list.unshift(this.custom_tag_list);
        if (this.callback.tags.length === 0 && res?.used_labels) {
          this.callback.tags = res.used_labels;
        }
        this.callback.tags.forEach(e => {
          if (e?.type) {
            this.tag.response.list[0].labels.push(e.content);
          }
          this.show_data.tags_length += e.content.length;
        });
        this.loading = false;
      });
    },
    /**
     * 选择标签
     * @param {string} tag 标签内容
     * @param {string} category 标签分类
     */
    tagCheck(tag, category) {
      const target = this.callback.tags;
      const tag_json = {
        content: tag,
      };
      category === '自定义标签' && (tag_json.type = 'LABEL_TYPE_CUSTOMIZETEXT');
      let tags_length = 0;
      target.forEach((item) => {
        tags_length += item.content.length;
      });
      const res = target.some((item) => {
        if (item.content === tag) {
          return true;
        }
      });
      // 如果没有选择
      if (!res) {
        tags_length += tag.length;

        if (target.length >= 3) {
          this.$message.warning('最多选择3个标签');
          return;
        }
        if (tags_length > this.limit.max_length) {
          this.$message.warning(`标签字数不能超过${this.limit.max_length}个字`);
          return;
        }

        target.push(tag_json);
        this.show_data.tags_length = tags_length;
      } else {
        target.splice(
          target.findIndex((item) => item.content === tag),
          1
        );
        this.show_data.tags_length = tags_length - tag.length;
      }
      this.callback.tags = target;
    },
    /** 自定义标签回车事件 */
    handleCustomTag() {
      const val = this.custom_tag.trim();
      const length = val.toString().length;
      if (length > 1 && length < 8) {
        if (this.callback.tags.length >= 3) {
          this.$message.warning('最多选择3个标签');
          return;
        }
        if (this.show_data.tags_length + length > this.limit.max_length) {
          this.$message.warning(`标签字数不能超过${this.limit.max_length}个字`);
          return;
        }
        if (this.callback.tags.some(e => e.content === val)) {
          this.$message.warning(`标签【${val}】已选中，请勿重复生成标签！`);
          return;
        }
        for (const item of this.tag.response.list) {
          if (item.labels.includes(val)) {
            this.tagCheck(val, item.label_category);
            this.custom_tag = '';
            this.$message.warning(`标签【${val}】已存在,已为您自动选择！`);
            return;
          }
        }
        this.tag.response.list[0].labels.push(val);
        this.callback.tags.push({
          content: val,
          type: 'LABEL_TYPE_CUSTOMIZETEXT',
        });
        this.show_data.tags_length += length;
        this.custom_tag = '';
      } else {
        this.$message.warning('请按规定的字数输入标签文案！');
      }
    },
    /** 取消 */
    cancel() {
      this.$emit('cancel');
    },
    /** 确定 */
    confirm() {
      this.cancel();
      this.$emit('confirm', this.callback.tags);
    },
  },
};
</script>

<style rel="stylesheet/scss" scoped lang="scss">
.tag-dialog {
  min-width: 1010px;
  max-width: 1065px;
  .custom-input {
    margin-top: 20px;
    width: 400px;
  }
  .tag-box {
    height: 600px;
    overflow: auto;
    .tag_button {
      float: right;
      margin-left: 5px;
    }
    .tips_box {
      line-height: 20px;
      .tips {
        vertical-align: middle;
        font-size: 20px;
      }
    }
    .tag_item {
      margin-bottom: 5px;
    }
  }
  footer {
    i {
      color: #7f7f7f;
    }
  }
}
</style>
